var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DevNotes',[_vm._v(" Advisor : 0% Development Notes - แสดงการ Chat กับที่อาจารย์ปรึกษา ")]),_c(_vm.getCurrentStage().k,{tag:"component",attrs:{"classroomId":_vm.classroomId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }